import {text_mod_39, } from "../text/Text.js";
export const module39 = {
  title:
    "§39. Повторення вивченого про іменник",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_39, },
    ]
  }
